var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortDown = function SvgSortDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.805 38.754V5.625h-3v33.129l-5.193-5.193-2.121 2.121 8.814 8.814 8.813-8.814-2.121-2.121zm24.704-17.282-8.814-8.813-8.813 8.813 2.121 2.121 5.192-5.192v13.244h3V18.401l5.193 5.192z"
  })))));
};
export default SvgSortDown;